<template>
  <LoadingScreen v-if="!$store.state.creatorPage" />
  <div>
    <TsHero />
    <div>
      <BrandsLogos />
    </div>
    <div class="ts-container-fluid container-fluid">
      <HowItWorks />
    </div>
    <div class="ts-container-fluid container-fluid">
      <CreatorsReviews>
        <h3
          class="ts-fs-1 text-center ts-text-gray-5 fw-bold mb-07 mb-lg-13"
          v-if="$store.state.creatorPage"
        >
          {{ $store.state.creatorPage.Testimonial.title }}
          <span class="ts-text-primary-1">
            {{ $store.state.creatorPage.Testimonial.titleHighlighted }}</span
          >
          {{ $store.state.creatorPage.Testimonial.title2 }}
        </h3>
      </CreatorsReviews>
      <LastestNews>
        <h3
          class="ts-fs-1 ts-text-gray-5 text-center fw-bold mb-08 mb-lg-13"
          v-if="$store.state.creatorPage"
        >
          {{ $store.state.creatorPage.BlogSectionTitle }}
        </h3>
      </LastestNews>
    </div>
  </div>
</template>

<script>
import LoadingScreen from "../components/Common/LoadingScreen.vue";
import TsHero from "../components/Creators/TsHero.vue";
import BrandsLogos from "../components/Common/BrandsLogos.vue";
import HowItWorks from "../components/Creators/HowItWorks.vue";
import CreatorsReviews from "../components/Common/CreatorsReviews.vue";
import LastestNews from "../components/Common/LastestNews.vue";
import { useHead } from "@vueuse/head";
import { metaConfig } from "../config/meta";

export default {
  name: "CreatorsPage",
  components: {
    LoadingScreen,
    TsHero,
    BrandsLogos,
    HowItWorks,
    CreatorsReviews,
    LastestNews,
  },

  setup() {
    useHead({
      title: metaConfig.creators.title,
      meta: [
        ...metaConfig.creators.meta
          .filter((meta) => meta.name)
          .map((meta) => ({
            name: meta.name,
            content: meta.content,
            key: meta.name,
          })),
        ...metaConfig.creators.meta
          .filter((meta) => meta.property)
          .map((meta) => ({
            property: meta.property,
            content: meta.content,
            key: meta.property,
          })),
      ],
      link: [
        ...metaConfig.creators.meta
          .filter((meta) => meta.rel)
          .map((meta) => ({
            rel: meta.rel,
            href: meta.href,
            key: "canonical",
          })),
      ],
    });

    return {};
  },

  computed: {
    activeLanguage() {
      return this.$store.getters.activeLanguage;
    },
  },

  // Watch if ACtive language Change but not same as old Language
  watch: {
    activeLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$store.dispatch("getCreatorPage");
      }
    },
  },
  created() {
    this.$store.dispatch("getCreatorPage");
  },
};
</script>
